import { map } from 'rxjs/operators';
import { RestApi } from 'src/app/shared/RestApi/restApi';
import { Data } from '../jmigrator-tools/Data';
import { Observable, throwError } from 'rxjs';
import { Tool } from '../jmigrator-tools/Tool';
import { HttpHeaders, HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { catchError } from 'rxjs/internal/operators/catchError';
interface toolResponse{
  message : string
    error : boolean
  status: string
  }

  interface stateResponse{
    statusMessage : string
      error : boolean
    status: string
    }

  @Injectable({
    providedIn: 'root'
  })
export class JMigratorService{


  private  headers= new HttpHeaders({
      'Content-Type':'application/json'
    });

  tool: Tool[];

 constructor(
    private http: HttpClient,
    private restAPI: RestApi
  ) { }

  //service for retrieving the toolData
  getTools(): Observable<Tool[]>{
    return this.http.get<Tool[]>(this.restAPI.RETRIEVE_TOOLS).pipe(catchError(this.errorHandler));
   }

   // service for retrieving log data
  getToolLog(toolCatalogueId):Observable<Data[]>{
    return this.http.get<Data[]>(this.restAPI.RETRIEVE_TOOL_LOG +toolCatalogueId).pipe(catchError(this.errorHandler))
  }

  // service for converting Xml to Csv File
  XmlToCsvToSql(path){
    console.log(path);
    return this.http.post<toolResponse>(this.restAPI.XML_TO_CSV_SQL ,JSON.stringify(path),{headers:this.headers});
  }

  // service for modify the Xml files
  XmlModifier(path){
    console.log(path);
    return this.http.post<toolResponse>(this.restAPI.XML_MODIFIER,JSON.stringify(path),{headers:this.headers})
  }

  //cservice for splitting the Xml file
  xmlSplitter(path){
    console.log(path);
    return this.http.post<toolResponse>(this.restAPI.XML_SPLITTER,JSON.stringify(path),{headers:this.headers})
  }

  // service for loading csv file to sql database
  csvToSql(csvToSQLData){
    return this.http.post<toolResponse>(this.restAPI.CSV_SQL,JSON.stringify(csvToSQLData),{headers:this.headers})
  }

  public download_test(supportingDoc): Observable<Blob> {

    return this.http.get(supportingDoc, { responseType: 'blob' });
  }

  public download_zip(supportingDoc): Observable<ArrayBuffer> {

    return this.http.get(supportingDoc, { responseType:'arraybuffer' });
  }

  public download_zip_ForPostUrl(url: string, body: any): Observable<ArrayBuffer> {
    return this.http.post(url, body, { responseType: 'arraybuffer' });
  }
   postFile(statevaluechange,dnsName,dnsId){
    console.log(statevaluechange);
    // const formData : FormData = new FormData();
    // formData.append('fileKey',fileToUpload,fileToUpload.name);
    // console.log(formData);
    return this.http.post<stateResponse>(this.restAPI.Update_Case_State+"/"+dnsName+"/"+dnsId,JSON.stringify(statevaluechange),{headers:this.headers})
  }

  updateProductTypeService(statevaluechange,dnsName,dnsId){
    console.log(statevaluechange);
    // const formData : FormData = new FormData();
    // formData.append('fileKey',fileToUpload,fileToUpload.name);
    // console.log(formData);
    return this.http.post<stateResponse>(this.restAPI.UPDATE_PRODUCT_TYPE_CHANGE+"/"+dnsName+"/"+dnsId,JSON.stringify(statevaluechange),{headers:this.headers})
  }

  getActionItems(statevaluechange,dnsName){
    return this.http.post<stateResponse>(this.restAPI.RETRIEVE_CASE_STATE_USERACTIONS+"/"+dnsName,JSON.stringify(statevaluechange),{headers:this.headers})
  }

//Modified by-Abhishek Tomar
//03-09-2023
//sending data in multipart
  postZipFile(statevaluechange, toolCatalogueId,workspaceId) {
    const formData = new FormData();
  
    // Create a Blob from statevaluechange.fileData
    const fileBlob = new Blob([statevaluechange.fileData]);
  
    // Append the 'file' part
    formData.append('file', fileBlob, statevaluechange.fileName); // Change 'yourFileName.zip' to the desired file name
  
    // Clear the 'fileData' to avoid duplication
    statevaluechange.fileData = null; // Use null to clear the fileData
  
    // Append the 'data' part as JSON
    formData.append('data', JSON.stringify(statevaluechange));
  
    return this.http.post<toolResponse>(
      `${this.restAPI.ZIP_FILE_EXTRACT}/${toolCatalogueId}/${workspaceId}`,
      formData
    );
  }
  
  

  
  

  retrieveStateChange(dnsId){
    return this.http.get<stateResponse>(this.restAPI.RETRIEVE_UPDATE_CASE_STATE+"/"+dnsId,{headers:this.headers})
  }

/**
 * @author Abhishek
 * @description From here we are calling the service
 * @param dnsId
 * @returns
 */
  retrieveR3Extractor(dnsId){
    return this.http.get<stateResponse>(this.restAPI.RETRIEVER3EXTRACTOR+"/"+dnsId,{headers:this.headers})
  }

  uploadR3Extractor(statevaluechange){
    return this.http.post<stateResponse>(this.restAPI.UPLOADR3EXTRACTOR,JSON.stringify(statevaluechange),{headers:this.headers})
  }


errorHandler(error){
    let errorMessage='';
    if(error.error instanceof ErrorEvent){
      errorMessage=error.error.message;
    }
    else{
      errorMessage=`Error Code:${error.status}\nMessage:${error.message}`;
    }
    console.log(errorMessage);
    return throwError(errorMessage);
  }

uploadCaseAuditExtraction(formData){

 return this.http.post(

   this.restAPI.UPLOAD_CASE_AUDIT_EXTRACTION,

   formData

 );

}


getCaseAuditRefresh(){
   return this.http.get(
    this.restAPI.REFRESH_CASE_AUDIT_EXTRACTION
   );
}

uploadOracleExcel(formData){

 return this.http.post(

   this.restAPI.UPLOAD_ORACLE_DATA,

   formData

 );

}
refreshOracle(){
   return this.http.get(
    this.restAPI.REFRESH_ORACLE_DATA
   );
}

getDataExtractorUsernameConfig(){
  return this.http.get<any>(this.restAPI.GET_DATA_EXTRACTOR_USERNAME_CONFIG);
}

updateDataExtractorUsernameConfig(data){
  return this.http.put<any>(this.restAPI.UPDATE_DATA_EXTRACTOR_USERNAME_CONFIG, data);
}

getDataExtractorDashboardCounts() {
    return this.http.get<any>(
      this.restAPI.DATA_EXTRACTOR_DASHBOARD_COUNTS
    );
}

getCurrentSourceCsvPath() {
  return this.http.get<any>(
    this.restAPI.GET_CURRENT_SOURCE_CSV
  );
}

}
